import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './index.css'; // Optional: for custom styling

function NotFound() {
  useEffect(() => {
    document.title = 'Page not found | Stixify Web'
  }, [])

  return (
    <div className="not-found">
      <h1>404 - Page Not Found</h1>
      <p>Oops! The page you are looking for does not exist.</p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
}

export default NotFound;
